import { Box, BoxProps, Text } from '@chakra-ui/react';
import { getDeletedMessageSx } from './sxStyles';

export interface DeletedMessageProps extends BoxProps {
  isCurrentUser?: boolean;
}

export const DeletedMessage = ({
  isCurrentUser,
  ...rest
}: DeletedMessageProps) => {
  const { containerSx, textSx } = getDeletedMessageSx(isCurrentUser);
  return (
    <Box sx={containerSx} {...rest}>
      <Text sx={textSx}>This message has been deleted</Text>
    </Box>
  );
};
